import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  eventDetails: null,
  matchTimeline: null,
};


export const matchTimelineSlice = createSlice({
  name: 'matchTimeline',
  initialState,
  reducers: {
    aGetMatchTimelineSuccess: (state, action) => {
      state.eventDetails = action.payload.eventDetails;
      state.matchTimeline = action.payload.matchTimeline;
    },
    aClearMatchTimeline: (state) => {
      state.eventDetails = null;
      state.matchTimeline = null;
    },
    aGetTennisMatchTimelineSuccess: (state, action) => {
      state.tennisEventDetails = action.payload.eventDetails;
      state.tennisMatchTimeline = action.payload.matchTimeline;
    },
    aClearTennisMatchTimeline: (state) => {
      state.tennisEventDetails = null;
      state.tennisMatchTimeline = null;
    },
  },
});

export const {
  aGetMatchTimelineSuccess,
  aClearMatchTimeline,
  aGetTennisMatchTimelineSuccess,
  aClearTennisMatchTimeline,
} = matchTimelineSlice.actions;

export default matchTimelineSlice.reducer;

